import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { alertMsg } from "../utilities/helper";
import { url, domain } from "./api";

const initialState = {
  loading: false,
  user: null,
  success: null,
  error: "",
};

//login service
export const loginAction = createAsyncThunk(
  "user/login",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await axios({
        method: "POST",
        url: `${domain}/loginAdmin`,
        data: {
          email: obj.email,
          password: obj.password,
        },
      });

      alertMsg("تم تسجيل الدخول بنجاح", true, "ar");
      return response;
    } catch (err) {
      toast.error("فشل تسجيل الدخول", false, "ar");

      return rejectWithValue(err);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loginAction.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(loginAction.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload.data.access_token;
      state.success = action.payload.data.success;
    });
    builder.addCase(loginAction.rejected, (state, action) => {
      state.user = null;
      state.loading = false;
      state.success = action.payload.response.data.success;
      state.error = action.payload.response.data.error;
    });
  },
});
export default authSlice.reducer;
